import { ReactNode } from 'react'
import classnames from 'classnames'
import styles from './Button.module.scss'
import { Icon } from 'components/Icon/Icon'

type Props = {
    children: ReactNode;
    size: 'l' | 'm' | 's' | 'xs',
    type: 'dark' | 'light' | 'primary' | 'border' | 'transparent';
    onClick?: () => void;
    behaviourType?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
    iconName?: string;
    stretch?: boolean;
    iconRight?: boolean;
};

export function Button(props: Props): JSX.Element {
    const buttonClassNames = classnames({
        [styles['button']]: true,
        [styles[`button_${props.type}`]]: true,
        [styles[`button_${props.size}`]]: true,
        [styles['button_stretch']]: props.stretch,
        [styles['button_icon-right']]: props.iconRight,
    })


    return (
        <button
            type={props.behaviourType}
            className={buttonClassNames}
            onClick={props.onClick}
            disabled={props.disabled}
        >
            {props.iconName && (
                <div className={styles['icon']}>
                    <Icon name={props.iconName} />
                </div>
            )}
            <div className={styles['text']}>{props.children}</div>
        </button>
    );
}

Button.defaultProps = {
    behaviourType: 'button',
    type: 'dark',
    stretch: true,
    iconRight: false
};
